import type { AppBarProps as MuiAppBarProps } from '@mui/material';
import { AppBar as MuiAppBar } from '@mui/material';

export type AppBarProps = MuiAppBarProps;

// TODO: overwrite color prop in theme

/**
 * AppBar component. Based on MUI AppBar: https://mui.com/material-ui/react-app-bar/
 * */
export const AppBar = (props: AppBarProps) => <MuiAppBar {...props} data-testid="app-bar" />;
